exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".video-container{display:flex;width:100%;height:100%;align-items:center;justify-content:center;margin-bottom:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/VideoPlayer/VideoPlayer.scss
// module id = 1683
// module chunks = 0